import * as React from "react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "../ui/tooltip";
import { Clock, Loader, XCircle } from "lucide-react";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";

interface StatusIconProps {
  currentStatus: string;
}

export const StatusIcon: React.FC<StatusIconProps> = ({ currentStatus }) => {
  if (currentStatus === "queued" || currentStatus === "pending") {
    return (
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger>
            <Clock className="size-3.5 text-neutral-400" />
          </TooltipTrigger>
          <TooltipContent>
            <p>In queue</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  }
  if (currentStatus === "processing") {
    return (
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger>
            <Loader className="size-3.5 animate-spin text-white" />
          </TooltipTrigger>
          <TooltipContent>
            <p>Processing...</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  }
  if (currentStatus === "processed" || currentStatus === "completed") {
    return (
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger>
            <IoMdCheckmarkCircleOutline className="size-3.5 text-white" />
          </TooltipTrigger>
          <TooltipContent>
            <p>Completed</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  }
  if (currentStatus === "failed") {
    return (
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger>
            <XCircle className="size-3.5 text-white" />
          </TooltipTrigger>
          <TooltipContent>
            <p>Failed</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  }
  return null;
};
